import {
  RULE_CHAIN_ITEMS_PER_PAGE,
  type SecuritySchemaState,
} from 'components/SecuritySchema/model/SecuritySchemaModel';
import { isRuleChainScope } from 'components/SecuritySchema/model/SecuritySchemaScope';

export const getRuleChainInitialPage = (s: SecuritySchemaState): number => {
  if (isRuleChainScope(s.scope)) {
    const highlightedRuleIndex = s.highlightedRules[s.scope.name];
    if (highlightedRuleIndex) {
      return Math.floor(highlightedRuleIndex / RULE_CHAIN_ITEMS_PER_PAGE);
    }
  }
  return 0;
};
